
import { defineComponent } from 'vue';
import InsightOffcanvas from './InsightOffcanvas.vue';
import IconMagic from '../Icon/IconMagic.vue';

const __default__ = defineComponent({
  components: {
    InsightOffcanvas,
    IconMagic,
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    aiName: {
      type: String,
      required: true,
    },
    aiLabel: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
    apiMethod: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      displayOffcanvas: false,
    };
  },
  methods: {
    onClick() {
      this.displayOffcanvas = !this.displayOffcanvas;
      this.$refs.offCanvas.onSubmit();
    },
    onClose() {
      this.displayOffcanvas = false;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "2ae6e728": (_ctx.aiColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__